import { render, staticRenderFns } from "./MessagesCenter.vue?vue&type=template&id=237c76ac"
import script from "./MessagesCenter.vue?vue&type=script&lang=js"
export * from "./MessagesCenter.vue?vue&type=script&lang=js"
import style0 from "./MessagesCenter.vue?vue&type=style&index=0&id=237c76ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports